import axios from 'axios';

export default {
    fetchWorkweek() {
        return axios.post('/workweek/fetchWorkweek/');
    },
    updateWorkweek(workweek) {
        return axios.post('/workweek/updateWorkweek/', { workweek });
    },
};
